module.exports = {
  title: '协议配置',
  route: {
    path: 'system-manage',
    children: {
      path: 'protocol-list',
    },
  },
};
